define(function(require,exports,module){
    var classinator = require( "es6ish-class/es6ish-class" );

    var noop = function(){};
    var noop_true = function(){return true};
    var switchboard = [document.body];
    var namespace = ".deviceInteraction";
    var INTERACTION = "click";
    var reCamelDash = /\-(\w)/ig;
    var dataPre = "data-";
    var EMPTY = '';
    var check = document.documentElement;
    var matchesFunction = check.matches
            || check.webkitMatchesSelector
            || check.mozMatchesSelector
            || check.msMatchesSelector
            || check.oMatchesSelector
            || function(){
                return false;
            };

    function camelCaper($0,$1){
            return $1.toUpperCase();
    }

    function dataSet(source){
        var attrs = source.attributes;
        var len = attrs.length;
        var dataset = {};
        var i = 0;
        var attr;
        var key;
        
        for (; i < len; i++) {
            attr = attrs[i];
            key = (attr.name || attr.nodeName || EMPTY);
            if(key.indexOf(dataPre)===0){
                dataset[key.replace(dataPre,EMPTY).replace(reCamelDash,camelCaper)] = attr.value || attr.nodeValue;
            }
        }
        return dataset;
    }

    function listenerFactory(di, method, selector){

        return function(e){
            var source = matchTargetPath(e, selector);
            if (source) {
                e.stopPropagation();
                e.preventDefault();
                di[method](source.dataset || dataSet(source));
            }
        }
    }

    function scanTree(e, selector){
        var source = e.target;
        do {
            if(matchesFunction.call(source, selector)){
                return source;
            }
            source = source.parentElement;
        } while(source);

        return false;
    }

    function matchTargetPath(e, selector){
        var path = e.path || e.deepPath || (e.composedPath && e.composedPath());

        if (!path) {
            return scanTree(e, selector);
        } else {
            var len = path.length;
            var i = 0;
            for(; i < len; i++){
                if (matchesFunction.call(path[i], selector)) {
                    return path[i];
                }
            }
        }
        return false;
    }

    function DeviceInteraction(){
        // Make sure calls don't fail if we don't have a valid dispatcher
        return this.dispatcher ? this : new DeviceInteraction();
    };

    DeviceInteraction.isDispatcherAvailable = false;
    DeviceInteraction.prototype={
        listen : function(selectorMap,scope){
            selectorMap = selectorMap || {};
            scope = scope ? document.querySelectorAll(scope) : switchboard;
            var di = this;
            var method;
            var type;
            var el;
            var i = 0;
            var len = scope.length;

            for(; i < len; i++ ){
                el = scope[i];
                for(type in selectorMap){
                    if(selectorMap.hasOwnProperty(type) && (type in di)){
                        el.addEventListener(INTERACTION, listenerFactory(di, type, selectorMap[type]),true);
                    }
                }
            }
        },
        dispatcher  : noop,
        close       : noop,
        track       : noop,
        video       : noop,
        webview     : noop,
        navigate    : noop,
        paywall     : noop,
        hasAccess   : noop_true,
        playercard  : noop,
        mlbtv       : noop,
        share       : noop,
        nhltv       : noop,
        audio       : noop,
        photo       : noop,
        articleshare: noop,
        has60fps    : noop_true,
        openArticle	: noop, 
        isDispatcherActive : function(){
            return false;
        },
        gameday  : noop,
        mlbtvapp : noop,
        milbtvapp : noop,
        tvapp : noop,
        mlbplayercard : noop,
        milbplayercard : noop,
        team : noop
    };

    classinator(DeviceInteraction);

    return  DeviceInteraction;
});